import { gql } from "@apollo/client";

export const GET_N8N_WORKFLOW_QUERY = gql`
  query GetN8nWorkflow($tenantId: String!, $workflowId: String!) {
    getN8nWorkflow(tenantId: $tenantId, workflowId: $workflowId) {
      id
      name
      nodes
      connections
      tenantId
      createdAt
      updatedAt
    }
  }
`;

export const LIST_N8N_WORKFLOWS_QUERY = gql`
  query ListN8nWorkflows($tenantId: String!) {
    listN8nWorkflows(tenantId: $tenantId) {
      id
      name
      tenantId
      createdAt
      updatedAt
    }
  }
`;
export const GET_EXECUTION_HISTORY_QUERY = gql`
  query GetExecutionHistory($input: GetExecutionHistoryInput!) {
    getExecutionHistory(input: $input) {
      id
      workflowId
    }
  }
`;
